import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-dark-gray/90 border-t border-gray-800 py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="mb-6">
              <img
                src="/logo.png"
                alt="SAMFREN OJO MEDIA Logo"
                className="h-24 w-auto"
              />
            </div>
            <p className="text-gray-400 text-sm mb-4">
              Capturing moments, telling stories,<br />
              and creating visual experiences<br />
              that last a lifetime.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.instagram.com/samfrenojomedia/"
                className="text-gray-400 hover:text-burnt-orange transition-colors"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <i className="fa-brands fa-instagram text-2xl"></i>
              </a>
              <a
                href="https://www.youtube.com/@samfrenojo"
                className="text-gray-400 hover:text-burnt-orange transition-colors"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
              >
                <i className="fa-brands fa-youtube text-2xl"></i>
              </a>
              <a
                href="https://www.tiktok.com/@samfrenojo?_t=ZM-8ySurqwn55M&_r=1"
                className="text-gray-400 hover:text-burnt-orange transition-colors"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="TikTok"
              >
                <i className="fa-brands fa-tiktok text-2xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-gray-400 hover:text-burnt-orange transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-burnt-orange transition-colors text-sm">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="text-gray-400 hover:text-burnt-orange transition-colors text-sm">
                  Gallery
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-burnt-orange transition-colors text-sm">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Contact Us</h3>
            <ul className="space-y-2">
              <li className="flex items-start">
                <svg className="h-5 w-5 text-burnt-orange mr-2 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <span className="text-gray-400 text-sm">Abuja, Nigeria</span>
              </li>
              <li className="flex items-center">
                <svg className="h-5 w-5 text-burnt-orange mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <a href="mailto:samfrenojomedia@gmail.com" className="text-gray-400 hover:text-burnt-orange transition-colors text-sm">
                  info@samfrenojomedia.com
                </a>
              </li>
              <li className="flex items-center">
                <svg className="h-5 w-5 text-burnt-orange mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <a href="tel:+2348108535984" className="text-gray-400 hover:text-burnt-orange transition-colors text-sm">
                  +234 810 853 5984
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-center items-center gap-2 text-gray-400 text-sm text-center">
            <p>&copy; {currentYear} SAMFREN OJO MEDIA. All rights reserved.</p>
            <span className="hidden md:inline">•</span>
            <p>
              POWERED BY{' '}
              <a
                href="https://www.belsoftsystems.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-burnt-orange hover:underline"
              >
                BELSOFT SYSTEMS LTD
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
